const DOCUMENT = "CITY_";

const actions = {
  LOAD_FROM_FIRESTORE: DOCUMENT + "LOAD_FROM_FIRESTORE",
  LOAD_FROM_FIRESTORE_SUCCESS: DOCUMENT + "LOAD_FROM_FIRESTORE_SUCCESS",
  LOAD_FROM_FIRESTORE_ERROR: DOCUMENT + "LOAD_FROM_FIRESTORE_ERROR",

  LOAD_CITIES: DOCUMENT + "LOAD_CITIES",
  LOAD_CITIES_SUCCESS: DOCUMENT + "LOAD_CITIES_SUCCESS",

  LOAD_CITIES_SELECTOR: DOCUMENT + "LOAD_CITIES_SELECTOR",
  LOAD_CITIES_SELECTOR_SUCCESS: DOCUMENT + "LOAD_CITIES_SELECTOR_SUCCESS",

  LOAD_BY_PROPERTY_FROM_FIRESTORE: DOCUMENT + "LOAD_BY_PROPERTY_FROM_FIRESTORE",
  LOAD_BY_PROPERTY_FROM_FIRESTORE_SUCCESS:
    DOCUMENT + "LOAD_BY_PROPERTY_FROM_FIRESTORE_SUCCESS",
  LOAD_BY_PROPERTY_FROM_FIRESTORE_ERROR:
    DOCUMENT + "LOAD_BY_PROPERTY_FROM_FIRESTORE_ERROR",

  SAVE_INTO_FIRESTORE: DOCUMENT + "SAVE_INTO_FIRESTORE",
  SAVE_INTO_FIRESTORE_ERROR: DOCUMENT + "SAVE_INTO_FIRESTORE_ERROR",

  RESET_FIRESTORE_DOCUMENTS: DOCUMENT + "RESET_FIRESTORE_DOCUMENTS",
  RESET_FIRESTORE_DOCUMENTS_ERROR: DOCUMENT + "RESET_FIRESTORE_DOCUMENTS_ERROR",

  TOGGLE_FIRESTORE_HANDLE_MODAL: DOCUMENT + "TOGGLE_FIRESTORE_HANDLE_MODAL",
  FIRESTORE_UPDATE: DOCUMENT + "FIRESTORE_UPDATE",

  loadFromFireStore: () => {
    return { type: actions.LOAD_FROM_FIRESTORE };
  },

  loadFromFireStoreSuccess: (data) => ({
    type: actions.LOAD_FROM_FIRESTORE_SUCCESS,
    payload: { data },
  }),

  loadFromFireStoreError: (error) => ({
    type: actions.LOAD_FROM_FIRESTORE_ERROR,
    payload: { error },
  }),

  loadCities: (filterCity) => ({
    type: actions.LOAD_CITIES,
    payload: { filterCity},
  }),

  loadCitiesSuccess: (data) => ({
    type: actions.LOAD_CITIES_SUCCESS,
    payload: { data },
  }),

  loadCitiesSelector: (filterCity) => ({
    type: actions.LOAD_CITIES_SELECTOR,
    payload: { filterCity },
  }),

  loadCitiesSelectorSuccess: (data) => ({
    type: actions.LOAD_CITIES_SELECTOR_SUCCESS,
    payload: { data },
  }),

  loadByPropertyFromFireStore: (data) => {
    return { type: actions.LOAD_BY_PROPERTY_FROM_FIRESTORE, payload: { data } };
  },

  loadByPropertyFromFireStoreSuccess: (data) => ({
    type: actions.LOAD_BY_PROPERTY_FROM_FIRESTORE_SUCCESS,
    payload: { data },
  }),

  loadByPropertyFromFireStoreError: (error) => ({
    type: actions.LOAD_BY_PROPERTY_FROM_FIRESTORE_ERROR,
    payload: { error },
  }),

  saveIntoFireStore: (data, actionName = "insert") => ({
    type: actions.SAVE_INTO_FIRESTORE,
    payload: { data, actionName },
  }),

  toggleModal: (data = null) => ({
    type: actions.TOGGLE_FIRESTORE_HANDLE_MODAL,
    payload: { data },
  }),

  update: (data) => {
    return {
      type: actions.FIRESTORE_UPDATE,
      payload: { data },
    };
  },

  saveIntoFireStoreError: (error) => ({
    type: actions.SAVE_INTO_FIRESTORE_ERROR,
    payload: { error },
  }),

  resetFireStoreDocuments: () => ({
    type: actions.RESET_FIRESTORE_DOCUMENTS,
  }),

  resetFireStoreDocumentsError: (error) => ({
    type: actions.RESET_FIRESTORE_DOCUMENTS_ERROR,
    payload: { error },
  }),
};
export default actions;
